import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/redux';

/**
 * Wraps authenticated routes. Redirects to /login if not authenticated.
 * Preserves the attempted URL so login can redirect back.
 */
export const RequireAuth: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};

/**
 * Wraps guest-only routes (login, signup). Redirects to /dashboard if already authenticated.
 */
export const GuestOnly: React.FC = () => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
